'use strict'
const suffix = process.env.NODE_ENV === 'production' ? '' : '.js'

// 域名注册-查询域名是否可注册
export const CREATE_DOMAIN_CHECK = '/client/domain/check' + suffix



// WEBPACK FOOTER //
// ./src/actions/domainRegistration.js